// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import { getLocal, setLocal, delLocal, delSession, getSessionStorage, setSessionStorage } from './assets/storage'
import broadcast from '@/assets/broadcast'; //全局广播组件


Vue.use(ElementUI)
Vue.prototype.img_host = 'https://pgyh5.oss-cn-hangzhou.aliyuncs.com/zyWeb';
Vue.prototype.$getLocal = getLocal;
Vue.prototype.$setLocal = setLocal;
Vue.prototype.$delLocal = delLocal;
Vue.prototype.$delSession = delSession;
Vue.prototype.$getSessionStorage = getSessionStorage;
Vue.prototype.$setSessionStorage = setSessionStorage;
Vue.prototype.$broadcast = broadcast; //设置全局广播组件变量 页面中有$on事件时页面销毁时需要$off监听事件

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js